import { ReactComponent as Loading } from '../../components/common/loader.svg';

interface ILoaderProps {
  hide: boolean;
}

const Loader = ({ hide }: ILoaderProps) => {
  return (
    <div className={`table_loader${hide ? ' table_loader--hide' : ''}`}>
      <Loading />
    </div>
  );
};

export default Loader;
